export default function convertMsToDuration(ms) {
  return new Date(ms).toISOString().substr(14, 5);
}
